module.exports = __webpack_public_path__ + "img/2.80f23182.jpg";